module.exports = __webpack_public_path__ + "static/media/places.8602afb5.svg";